import React from 'react';

/**
 * Kodema platform logo (docs/LOGO.md).
 *
 * <Logo />      "CONVERTER" wordmark with "BY KODEMA" set small underneath
 * <LogoMark />  monogram for favicons and app icons: open white "C" on a black rounded square
 */

const SIZES = {
  sm: {word: 'text-xl', by: 'text-[7px] mt-0.5'},
  md: {word: 'text-[28px]', by: 'text-[9px] mt-1'},
  lg: {word: 'text-5xl', by: 'text-xs mt-1.5'},
};

const Logo = ({size = 'md', align = 'start', inverted = false, className = ''}) => {
  const s = SIZES[size] || SIZES.md;
  return (
    <div
      role='img'
      aria-label='Converter by Kodema'
      className={`inline-flex flex-col font-brand leading-none select-none ${inverted ? 'text-white' : 'text-black'} ${align === 'center' ? 'items-center' : 'items-start'} ${className}`}
    >
      <span aria-hidden='true' className={`${s.word} font-semibold tracking-tight`}>CONVERTER</span>
      {/* Negative right margin cancels the trailing letter-spacing so centring stays true. */}
      <span aria-hidden='true' className={`${s.by} font-semibold tracking-[0.32em] mr-[-0.32em]`}>
        BY KODEMA
      </span>
    </div>
  );
};

export const LogoMark = ({className = 'h-9 w-9', title = 'Converter by Kodema', ...rest}) => (
  <svg viewBox='0 0 64 64' className={className} role='img' aria-label={title} {...rest}>
    <rect width='64' height='64' rx='14' fill='#000' />
    <path d='M43.5 22.4A15 15 0 1 0 43.5 41.6' fill='none' stroke='#fff' strokeWidth='7' strokeLinecap='round' />
  </svg>
);

export default Logo;
